<template>
  <div class="relative" :class="['fullscreen-wrapper', { fullscreen: isFullscreen }]">
    <div class="mt-2" v-if="orderListId">

      <div class="d-flex justify-content-between align-items-center mb-2 p-2"
           :style="{
                    backgroundColor: isFullscreen ? 'grey' : 'white',
                    position: isFullscreen ? 'sticky' : 'static',
                    zIndex: isFullscreen ? '99999' : '0',
                    top: isFullscreen ? '-20px' : null}">
        <h6 class="mb-0" :style="{color: isFullscreen ? 'white' : 'inherit'}">{{ title }}
          <b>{{ selectedOrder?.order_number }}</b></h6>

        <button class="btn btn-sm" :class="{'btn-outline-primary' : !isFullscreen}" @click="toggleFullscreen">
          <template v-if="isFullscreen">
            <div style="position:sticky; top:0">
              <i class="bi bi-fullscreen-exit me-2"></i>
              <span>Wyjdź z trybu pełnego ekranu</span>
            </div>
          </template>
          <template v-else>
            <div>
              <i class="bi bi-fullscreen me-2"></i>
              <span>Pełny ekran</span>
            </div>
          </template>
        </button>
      </div>

      <ejs-grid ref="orderListItemsGrid" id="orderListItemsGridId" :height="isFullscreen ? '65vh' : '24vh'"
                :dataSource="orderListItems"
				:rowHeight="32"
                :allowTextWrap='false'
                :allowExcelExport='true'
                :allowPaging="true"
                :allowSorting='true'
                :allowFiltering='true'
                :allowReordering='true'
                :allowResizing='true'
                :showColumnChooser='true'
                :allowSelection='true'
                :enablePersistence='true'
                :pageSettings="pageSettings"
                :editSettings="editSettings"
                :filterSettings="filterOptions"
                :toolbar="toolbar"
                :contextMenuItems="contextMenuItems"
                :selectionSettings="selectionOptions"
                :toolbarClick="clickToolbarHandler"
                :contextMenuClick="clickContextMenuHandler"
                :actionBegin="actionBeginHandler"
                :actionComplete="actionCompleteHandler"
                @contextMenuOpen="onContextMenuOpen"
                :rowDataBound="rowDataBound"
                :rowSelecting="rowSelecting"
                :cellEdit="cellEdit"
                :cellSave="onCellSave"
                :keyPressed="onKeyDown">
        <e-columns  v-if="userID === 7">
               <e-column type="number" headerText="L.p." width="70" :template="'indexTemplate'"
                          :allowEditing="false" :allowSorting="false" :allowFiltering="false"/>
         <e-column type="checkbox" width="100"/>
          <e-column field="id" headerText="Nr Poz." :allowEditing="false" isPrimaryKey="true"
                    :visible="false" :filter="filterDefault" headerTextAlign="Left"/>
          <e-column field="order_list.order_number" headerText="Numer zamówienia" :allowEditing="false"
                    :filter="filterDefault" width="200" type="string" headerTextAlign="Left"></e-column>
          <e-column field="project.number" headerText="Projekt" :allowEditing="false" :visible="true" headerTextAlign="Left"></e-column>
<e-column
    field="article.description"
    headerText="Nazwa/Opis"
    width="200"
    :filter="filterDefault"
    :template="'articleDescriptionTemplate'"
	 headerTextAlign="Left">
</e-column>
				
<e-column
  field="quote_request.updated_at"
  headerText="Data wysłania maili"
  :allowEditing="false"
  :filter="filterDefault"
  type="date"
  editType="datepickeredit"
  format="dd.MM.yyyy"
   headerTextAlign="Left"
> 
</e-column>
         <e-column field="delivery_date_deadline" headerText="Termin dostawy" :allowEditing="true"
                    :filter="filterDefault" format="dd.MM.yyyy" type="date" editType="datepickeredit" headerTextAlign="Left"></e-column>
        <e-column field="price_netto" headerText="Cena netto" :allowEditing="true" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="price_brutto" headerText="Cena brutto" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="quantity_required" headerText="Ilość zamawiana" :allowEditing="false" format="N2"
                    :filter="filterNumeric" type="number" textAlign="Right" headerTextAlign="Left"></e-column>
                <e-column field="article.article_unit.name" headerText="J.m." width="105" headerTooltip="J.m."
                          :allowEditing="false" :template="'artUnitTpl'"/>
           <e-column field="value_netto" headerText="Wartość netto" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="value_brutto" headerText="Wartość brutto" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
         <e-column field="rabate" headerText="Rabat (%)" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
         <e-column field="value_netto_po_rabacie" headerText="Wartość Netto po rabacie" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
         <e-column field="value_brutto_po_rabacie" headerText="Wartość Brutto po rabacie" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="created_at" headerText="Data utworzenia" :allowEditing="false" type="date"
                    format="dd.MM.yyyy" :filter="filterDefault" headerTextAlign="Left"></e-column>
		  <e-column field="created_by_name" headerText="Utworzone przez" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
 					
					
          <e-column field="article.catalog_number" headerText="Nr artykułu" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left" :visible="false"></e-column>
          <e-column field="article.model" headerText="Model artykułu" :allowEditing="false"
                    :filter="filterDefault" :visible="false" headerTextAlign="Left"></e-column>
           <e-column field="vat" headerText="VAT" :allowEditing="true" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N0" textAlign="Right" headerTextAlign="Left" :visible="false"></e-column>
          <e-column field="euro_rate" headerText="Kurs waluty" :allowEditing="true" editType="numericedit" format="N4"
                    :filter="filterDefault" type="number" textAlign="Right" headerTextAlign="Left" :visible="false"></e-column>
<e-column field="status.id" headerText="Status" :allowEditing="true" editType="dropdownedit"
          foreignKeyValue="name" foreignKeyField="id"
          :dataSource="order_list_statuses"
          :edit="orderItemStatusesParams"
          :filter="filterStatuses"
          :template="'statusColorsTemplate'" headerTextAlign="Left" :visible="false"/>
          <e-column field="comments" headerText="Komentarz do pozycji" :allowEditing="true"
                    :allowFiltering="false" :allowSorting="false"
                    :filter="filterDefault" headerTextAlign="Left" :visible="false"/>
         <e-column field="required_project_item.created_by_name" headerText="Zlecone przez" :allowEditing="false"
                          :filter="filterDefault" headerTextAlign="Left" :visible="false"/>
<e-column
    field="first_release_history.history_created_by_name"
    headerText="Zwolnił"
    :allowEditing="false"
    :filter="filterDefault"
	 headerTextAlign="Left"
	  :visible="false"
/>


          <e-column field="quote_request.request_number" headerText="Zapytanie ofertowe" :allowEditing="false"
                    :filter="filterDefault" :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="was_edited_later" width="80" headerTooltip="Wartość została zmieniona!" headerText="!"
                    :allowEditing="true" :allowFiltering="false" type="number" :edit="wasEditedLaterEdit"
                    editType="dropdownedit" :template="'wasEditedLaterTemplate'" :visible="false"/>
          <e-column field="team_name" headerText="Zespół" :allowEditing="false"  :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="article.id" headerText="ID artykułu" :allowEditing="false" :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="supplier.short_name" headerText="Wybrany dostawca" :allowEditing="false"
                    :filter="filterDefault" :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="send_to_mails" headerText="Maile" :allowEditing="false"
                    :filter="filterDefault" :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="send_to_mails_dw" headerText="Maile DW" :allowEditing="false"
                    :filter="filterDefault" :visible="false" headerTextAlign="Left"></e-column>

          <e-column field="delivered_quantity" headerText="Dostarczona ilość" :allowEditing="true"
                    :filter="filterNumeric" editType="numericedit" format="N2" type="number"
                    :edit="editNumbersPlusParams" textAlign="Right" :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="dispatched_quantity" headerText="Wydana ilość" :allowEditing="false" format="N2"
                    editType="numericedit"
                    :filter="filterNumeric" type="number" textAlign="Right" :visible="false" headerTextAlign="Left"></e-column>
          <template v-slot:deliverersShortNamesTemplate="{data}">
            {{ formatDeliverers(data) }}
          </template>
<template v-slot:articleDescriptionTemplate="{ data }">
  {{
    data.article?.description?.trim()
      ? data.article.description
      : data.article?.model
  }}
</template>
        </e-columns>
		
		
		<e-columns v-else>
               <e-column type="number" headerText="L.p." width="70" :template="'indexTemplate'"
                          :allowEditing="false" :allowSorting="false" :allowFiltering="false"/>
          <e-column type="checkbox" width="100"/>
          <e-column field="id" headerText="Nr Poz." :allowEditing="false" isPrimaryKey="true"
                    :visible="false" :filter="filterDefault" headerTextAlign="Left"/>
          <e-column field="order_list.order_number" headerText="Numer zamówienia" :allowEditing="false"
                    :filter="filterDefault" width="200" type="string" headerTextAlign="Left"></e-column>
          <e-column field="quote_request.request_number" headerText="Zapytanie ofertowe" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="required_project_items_id" headerText="Nr. pozycji zap." :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="was_edited_later" width="80" headerTooltip="Wartość została zmieniona!" headerText="!"
                    :allowEditing="true" :allowFiltering="false" type="number" :edit="wasEditedLaterEdit"
                    editType="dropdownedit" :template="'wasEditedLaterTemplate'" headerTextAlign="Left"/>
          <e-column field="project.number" headerText="Projekt" :allowEditing="false" :visible="true" headerTextAlign="Left"></e-column>
          <e-column field="team_name" headerText="Zespół" :allowEditing="false" :visible="true" headerTextAlign="Left"></e-column>
          <e-column field="article.id" headerText="ID artykułu" :allowEditing="false" :visible="false" headerTextAlign="Left"></e-column>
          <e-column field="article.catalog_number" headerText="Nr artykułu" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="article.model" headerText="Model artykułu" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="article.description" headerText="Nazwa/Opis" width="200"
                          :filter="filterDefault" headerTextAlign="Left"></e-column>					
          <e-column field="supplier.short_name" headerText="Wybrany dostawca" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="send_to_mails" headerText="Maile" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="send_to_mails_dw" headerText="Maile DW" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
<e-column
  field="quote_request.updated_at"
  headerText="Data wysłania maili"
  :allowEditing="false"
  :filter="filterDefault"
  type="date"
  editType="datepickeredit"
  format="dd.MM.yyyy"
   headerTextAlign="Left"
> 
</e-column>
          <e-column field="delivery_date_deadline" headerText="Termin dostawy" :allowEditing="true"
                    :filter="filterDefault" format="dd.MM.yyyy" type="date" editType="datepickeredit" headerTextAlign="Left"></e-column>
          <e-column field="quantity_required" headerText="Ilość zamawiana" :allowEditing="true" format="N2"
                    :filter="filterNumeric" editType="numericedit" type="number" :edit="editNumbersPlusParams" textAlign="Right" headerTextAlign="Left"></e-column>					
                <e-column field="article.article_unit.name" headerText="J.m." width="105" headerTooltip="J.m."
                          :allowEditing="false" :template="'artUnitTpl'"/>
           <e-column field="delivered_quantity" headerText="Dostarczona ilość" :allowEditing="true"
                    :filter="filterNumeric" editType="numericedit" format="N2" type="number"
                    :edit="editNumbersPlusParams" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="dispatched_quantity" headerText="Wydana ilość" :allowEditing="false" format="N2"
                    editType="numericedit"
                    :filter="filterNumeric" type="number" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="price_netto" headerText="Cena netto" :allowEditing="true" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="vat" headerText="VAT" :allowEditing="true" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N0" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="price_brutto" headerText="Cena brutto" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="value_netto" headerText="Wartość netto" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="value_brutto" headerText="Wartość brutto" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="rabate" headerText="Rabat (%)" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="value_netto_po_rabacie" headerText="Wartość Netto po rabacie" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
         <e-column field="value_brutto_po_rabacie" headerText="Wartość Brutto po rabacie" :allowEditing="false" type="number"
                    :filter="filterNumeric" editType="numericedit" format="N2" textAlign="Right" headerTextAlign="Left"></e-column>
		  <e-column field="currency" headerText="Waluta" :allowEditing="true" :edit="currenciesParams"
                    :filter="filterDefault" editType="dropdownedit" textAlign="Right" headerTextAlign="Left"></e-column>
          <e-column field="euro_rate" headerText="Kurs waluty" :allowEditing="true" editType="numericedit" format="N4"
                    :filter="filterDefault" type="number" textAlign="Right" headerTextAlign="Left"></e-column>
<e-column field="status.id" headerText="Status" :allowEditing="true" editType="dropdownedit"
          foreignKeyValue="name" foreignKeyField="id"
          :dataSource="order_list_statuses"
          :edit="orderItemStatusesParams"
          :filter="filterStatuses"
          :template="'statusColorsTemplate'" headerTextAlign="Left"/>
          <e-column field="comments" headerText="Komentarz do pozycji" :allowEditing="true"
                    :allowFiltering="false" :allowSorting="false"
                    :filter="filterDefault" headerTextAlign="Left"/>
          <e-column field="created_at" headerText="Data utworzenia" :allowEditing="false" type="date"
                    format="dd.MM.yyyy" :filter="filterDefault" headerTextAlign="Left"></e-column>
          <e-column field="required_project_item.created_by_name" headerText="Zlecone przez" :allowEditing="false"
                          :filter="filterDefault" headerTextAlign="Left"/>
		  <e-column field="created_by_name" headerText="Utworzone przez" :allowEditing="false"
                    :filter="filterDefault" headerTextAlign="Left"></e-column>
<e-column
    field="required_project_item.release_by_name"
    headerText="Zwolnił"
    :allowEditing="false"
    :filter="filterDefault"
	 headerTextAlign="Left"
/>

          <template v-slot:deliverersShortNamesTemplate="{data}">
            {{ formatDeliverers(data) }}
          </template>

        </e-columns>
 
               <template v-slot:indexTemplate="{data}">
                <span style="color:#a6a6a6">{{ ++data.index }}</span>
              </template>
 <template v-slot:template="{ data }">
    <span v-if="data.send_to_mails && data.send_to_mails.length">
      {{ data.quote_request?.updated_at }}
    </span>
    <span v-else></span>
  </template>
        <template v-slot:wasEditedLaterTemplate="{data}">
                <span
                    v-if="data.required_project_was_edited_later"
                    style="color: white; background-color: orangered; font-size:16px; font-weight: 700; width: 20px; display: block; text-align: center">
                  !
                </span>
        </template>

<template v-slot:statusColorsTemplate="{ data }">
 <div style="display: flex; align-items: center; gap: 8px;">
					<span 
					:style="{
						 backgroundColor: getStatusColor(data.status),
						width: '20px',
						height: '20px',
						display: 'inline-block',
						borderRadius: '4px'
					  }"
					  :title="data.status?.name"
					></span>
					<span>{{ data.status?.name }}</span>
				  </div>
</template>
<!-- J.m. -->
<template v-slot:artUnitTpl="{ data }">
  <div class="cell-stack">
    <div class="cell-main">
      {{ data.article?.article_unit?.name ?? '' }}
    </div>
    <div v-if="hasReplacement(data)" class="cell-replacement">
      {{ data.replacement?.article?.article_unit?.name ?? '' }}
    </div>
  </div>
</template>
<e-aggregates>
  <e-aggregate>
    <e-columns>

      <e-column
        field="value_netto_po_rabacie"
        type="Custom"
        :customAggregate="nettoByCurrency"
        footerTemplate="<b>${Custom}</b>"
      />

      <e-column
        field="value_brutto_po_rabacie"
        type="Custom"
        :customAggregate="bruttoByCurrency"
        footerTemplate="<b>${Custom}</b>"
      />

    </e-columns>
  </e-aggregate>
</e-aggregates>
      </ejs-grid>

      <teleport to="body">
        <MoveItemToWarehouseModal ref="moveItemToWarehouseModal" :project="selectedProjectId" :team="selectedTeamName"
                                  :selectedItems="selectedRecordsToMove"
                                  @update-grid="updateGrid"
                                  @added-success="successMsg" @added-error="errorMsg"
                                  @added-movement="refreshItemGrid"/>
      </teleport>

      <teleport to="body">
        <ChangeOrderListStatusModal :selectedRecords="selectedRecordsStat" ref="changeStatusModalRef"
                                    :statuses="[{id:6 , name:'Zatwierdzone'},{id:5 , name:'Anulowane'}]"
                                    @updated-article="refreshItemGrid"
                                    @added-success="successMsg" @added-error="errorMsg"/>
      </teleport>

      <teleport to="body">
        <AddOrderItemModal ref="addOrderItemModalRef" id="addOrderItemModal" :suppliers="suppliers" :units="units"
		:producers="producers" :categories="categories"  :selectedOrderId="orderListId" @added-success="successMsg"
		:project="selectedProjectId" :team="selectedTeamName" @added-error="errorMsg" @item-added="refreshItemGrid"/>
      </teleport>

    </div>
  </div>
</template>

<script>
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  AggregatesDirective,
  AggregateDirective,
  Page,
  Reorder,
  Aggregate,
  Resize,
  Sort,
  Toolbar,
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import SendOrdersModal from "./SendOrdersModal.vue";
import MoveItemToWarehouseModal from "./MoveItemToWarehouseModal.vue";
import {MultiSelect} from "@syncfusion/ej2-vue-dropdowns";
import {ComboBox, DropDownList} from "@syncfusion/ej2-dropdowns";
import {Predicate, Query} from "@syncfusion/ej2-data";
import AddOrderItemModal from "./AddOrderItemModal.vue";
import ChangeOrderListStatusModal from "../QuoteRequests/ChangeOrderListStatusModal.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

let statusObj, statusElem, dropInstanceFilterUnits, statusFilter;
export default {

  components: {
    ChangeOrderListStatusModal,
    AddOrderItemModal,
    SendOrdersModal,
    MoveItemToWarehouseModal,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    "e-aggregates": AggregatesDirective,
    "e-aggregate": AggregateDirective
  },

  emits: ['refresh'],

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, Aggregate]
  },

  props: {
    title: String,
    selectedOrder: Object,
    orderListId: Number,
    order_list_statuses: Object,
    selectedTeamName: String,
    selectedProjectId: Number | String,
    suppliers: Object,
    units: Object,
	userID: Number,
	producers: Object,
	categories: Object,
	 currencys: {
    type: Array,
    default: () => []

  },
  	table_settings: {
	type: Object,
	now_restore_table_items: {
			type: Number,
			default: 1
			},
	default: null
}

  },

watch: {
    table_settings: {
        immediate: true,
        deep: true,
        handler(value) {
            this.hasTableSettingsSel = !!(value?.settings);

            this.$nextTick(() => {
                const grid = this.$refs.orderListItemsGrid?.ej2Instances;

                if (grid) {
                    grid.toolbar = this.getToolbar();
                }
            });
        }
    },

    orderListId: {
        immediate: true,
        handler(newVal) {
            this.getItems(newVal);
        }
    }
},

  mounted() {
	this.restoreTableIfNeeded();
    const gridEl = document.getElementById('orderListItemsGridId');
    if (!gridEl) return;

    gridEl.addEventListener('mousedown', (e) => {
      if (e.which === 3) { // PPM
        this.preventRightClickSelection = true;
      }
    });
  },

  data() {
    return {
	  tableSettingsApplied: false,
	  hasTableSettingsSel: false,
      isFullscreen: false,
      preventRightClickSelection: false,
      hasPermission,
      orderListItems: [],
      selectedRecordsToMove: null,
      selectedRecordsStat: null,
      pageSettings: {pageSize: 200, pageCount: 5, pageSizes: [10, 20, 30, 50, 100, 200]},
      filterOptions: {type: "Menu", operator: 'contains'},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      isRestoring: false,
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      selectionOptions: {checkboxOnly: true},
      contextMenuItems: this.getContextMenu(),
      editNumbersPlusParams: {
        params: {
          min: 0,
          validateDecimalOnType: true
        }
      },

      wasEditedLaterEdit: {
        params: {
          dataSource: [
            {text: 'Tak', value: 1},
            {text: 'Nie', value: 0}
          ],
          query: new Query(),
          fields: {text: 'text', value: 'value'}
        }
      },

      currenciesParams: {
        create: () => {
          return document.createElement('input');
        },
        read: () => {
          return this.comboBoxObj.value;
        },
        destroy: () => {
          this.comboBoxObj.destroy();
        },
write: (args) => {
  this.comboBoxObj = new ComboBox({
    dataSource: this.currencys.map(currency => ({
      text: currency.name,
      value: currency.name
    })),
    fields: {
      text: 'text',
      value: 'value'
    },
  });

  this.comboBoxObj.appendTo(args.element);
}
      },

      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCategories: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.categories,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj kategorii',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterProducers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.producers,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj producentów',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: {text: 'short_name', value: 'short_name'},
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterWarehouses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.warehouses,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterStatuses: {
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            statusFilter = new DropDownList({
              dataSource: this.order_list_statuses,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj Statusu',
              popupHeight: '200px',
              allowFiltering: true
            });
            statusFilter.appendTo(flValInput);
          },
          write: (args) => {
            statusFilter.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, statusFilter.text);
          }
        }
      },

      orderItemStatusesParams: {
        create: () => {
          statusElem = createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.value;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: (args) => {
          statusObj = new DropDownList({
            dataSource: this.order_list_statuses,
            fields: {value: 'id', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never',
            value: args.rowData.status?.id,
            change: async (event) => {
              statusObj.value = await this.onChangeStatus(event, args.rowData);
            }
          });
          statusObj.appendTo(statusElem);
        }
      },

      inventoryStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.inventory_statuses,
            fields: {value: 'name', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });
          statusObj.appendTo(statusElem);
        }
      },
    }
  },

  methods: {
 	  restoreTableIfNeeded() {
    if (this.now_restore_table_items !== 0) {
      return;
    }

    let grid = this.$refs.orderListItemsGrid;

    if (!grid || !grid.$el || !grid.ej2Instances) {
      return;
    }

    let gridName = 'grid' + grid.$el.id;

    grid.ej2Instances.enablePersistence = false;

    window.localStorage.setItem(gridName, "");

    grid.ej2Instances.destroy();

    (function stripIdsFromUrl() {
      try {
        const url = new URL(window.location.href);

        url.searchParams.delete('ids');
        url.searchParams.delete('ids[]');

        history.replaceState(
          history.state,
          '',
          url.toString()
        );
      } catch (e) {
        const href = window.location.href;

        const cleaned = href
          .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
          .replace(/[?&]$/, '');

        history.replaceState(
          history.state,
          '',
          cleaned
        );
      }
    })();
	this.applyTableSettings();
    location.reload();
  }, 
  
  	applyTableSettings() {
    const grid = this.$refs.orderListItemsGrid?.ej2Instances;

    if (!grid || !this.table_settings?.settings) {
        return;
    }

	
    let settings;

    try {
        settings = JSON.parse(this.table_settings.settings);
		console.log('wczytano ustawienia')
    } catch (error) {
        console.error('Błąd odczytu ustawień tabeli:', error);
        return;
    }

    if (!Array.isArray(settings)) {
        return;
    }

    settings.forEach(setting => {
        if (!setting.field) {
            return;
        }

        const column = grid.columns.find(
            col => col.field === setting.field
        );

        if (!column) {
            return;
        }

        if (setting.width !== undefined) {
            column.width = setting.width;
        }

        column.visible = setting.visible !== false;
    });

    grid.refreshColumns();

    const savedFields = settings
        .filter(setting => setting.field)
        .sort((a, b) => a.index - b.index)
        .map(setting => setting.field);
    const currentFields = grid.columns
        .filter(column => column.field)
        .map(column => column.field);

    savedFields.forEach((field, targetIndex) => {
        const currentIndex = currentFields.indexOf(field);

        if (currentIndex === -1 || currentIndex === targetIndex) {
            return;
        }

        const targetField = currentFields[targetIndex];

        if (!targetField) {
            return;
        }

        grid.reorderColumns(
            field,
            targetField
        );

        currentFields.splice(currentIndex, 1);
        currentFields.splice(targetIndex, 0, field);
    });

    grid.refreshColumns();
},
hasReplacement(row) {
    return !!(row && row.replacement && row.replacement.article);
},
nettoByCurrency: function (data) {
    const rows = data?.result || data?.records || [];

    const sums = {};

    rows
        .filter(r => !r.deleted_at)
        .forEach(r => {
            const cur = r.currency || 'BRAK';
            const val = Number(r.value_netto_po_rabacie || 0);

            sums[cur] = (sums[cur] || 0) + val;
        });

    const format = new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const formatNumber = (value) =>
        format.format(value).replace(/\u00A0/g, ' ');

    return Object.entries(sums)
        .map(([cur, sum]) => `<b>${formatNumber(sum)} ${cur}</b>`)
        .join('<br/>');
},

bruttoByCurrency: function (data) {
    const rows = data?.result || [];

    const sums = {};

    rows
        .filter(r => !r.deleted_at)
        .forEach(r => {
            const cur = r.currency || 'BRAK';
            const val = Number(r.value_brutto_po_rabacie || 0);

            sums[cur] = (sums[cur] || 0) + val;
        });

    const format = new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const formatNumber = (value) =>
        format.format(value).replace(/\u00A0/g, ' ');

    return Object.entries(sums)
        .map(([cur, sum]) => `<b>${formatNumber(sum)} ${cur}</b>`)
        .join('<br/>');
},

rowDataBound(args) {
				   if (!this.tableSettingsApplied) {
        this.tableSettingsApplied = true;
        this.applyTableSettings();
    }
  const statusName =
    args.data?.status?.name ??
    args.data?.status_name ??
    '';

  const isCancelled = statusName === 'Anulowane';
  const isDeleted = !!args.data.deleted_at;

  if (isCancelled || isDeleted) {
    args.row.classList.add('text-muted', 'deleted-row');

    args.row.style.textDecoration = 'line-through';
    args.row.style.opacity = '0.65';
  }
},

    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;

      // opcjonalnie blokada scrolla dokumentu
      document.body.style.overflow = this.isFullscreen ? 'hidden' : '';
    },

    async getItems(newVal) {
      try {
	  
        const response = await axios.post(route('order-items-list.get', {orderList: newVal}));
        this.orderListItems = response.data;
      } catch (error) {
        console.error(error);
      }
	  
	    this.$nextTick(() => {
    setTimeout(() => {
      this.$refs.orderListItemsGrid?.ej2Instances?.refresh();
    }, 100);
  });
  
    },

    getEditSettings() {
      return {
        allowEditing: hasPermission('canEditOrders') || hasPermission('canChangeStatusApprovalOrders'),
        allowAdding: hasPermission('canEditOrders'),
        allowDeleting: hasPermission('canEditOrders'),
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

    getToolbar() {
      const tools = [];


	const urlParams = new URLSearchParams(window.location.search);

	let isApprovalOrder = urlParams.get('status') === 'W zatwierdzeniu';
	let isApprovalOrder1 = urlParams.get('status') === 'Zatwierdzone';

	if (hasPermission('canEditOrders') && (isApprovalOrder || isApprovalOrder1)) {
        tools.push(
            {text: "Dodaj", prefixIcon: 'e-add', id: 'add_btn'},
            {text: "Usuń", prefixIcon: 'e-delete', id: 'delete_btn'},
            "Cancel",
        )
      }

      if (hasPermission('canEditOrders') || (isApprovalOrder && hasPermission('canChangeStatusApprovalOrders'))) {
        tools.push(
            "Update",
        )
      }

      tools.push(
          {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
          {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
		  {text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
	if (this.hasTableSettingsSel) {	
		tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
	}
	tools.push(
          {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
          {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
          "ColumnChooser",
      );

      return tools;
    },

    clickToolbarHandler: async function (args) {
      /**
       * Niestandardowa akcja przy dodawaniu pozycji do zlecenia
       */
      if (args.item.id === 'add_btn') {
        this.$refs.addOrderItemModalRef.show();
      }

      /**
       * Niestandardowa akcja przy usuwaniu pozycji
       */
      if (args.item.id === 'delete_btn') {
        const selectedRecords = this.$refs.orderListItemsGrid.getSelectedRecords();

        if (!selectedRecords.length) {
          this.errorMsg('Nie zaznaczono żadnych pozycji do usunięcia.');
          args.cancel = true;
          return;
        }

        // Jeśli chcesz np. wysłać je do backendu
        const idsToDelete = selectedRecords.map(r => r.id);

        // Opcjonalnie: zrób swoje kasowanie zamiast domyślnego
        this.$refs.orderListItemsGrid.deleteRecord('id', selectedRecords[0]); // lub deleteRecords()

        // Zatrzymaj domyślną akcję grida
        args.cancel = true;
      }

      /**
       * Niestandardowa akcja przy aktualizacji
       */
      if (args.item.text === 'Aktualizuj') {
        const grid = this.$refs.orderListItemsGrid;

        // odczytanie zmian (Syncfusion trzyma to w tej właściwości)
        const batchChanges = grid.getBatchChanges(); // { added: [], changed: [], deleted: [] }

        // Zamiana kluczy na oczekiwane przez backend
        const payload = {
          added: batchChanges.addedRecords || [],
          changed: batchChanges.changedRecords || [],
          deleted: batchChanges.deletedRecords || []
        };


        // jeśli nie ma żadnych zmian, nie wysyłaj żądania
        if (
            payload.added.length === 0 &&
            payload.changed.length === 0 &&
            payload.deleted.length === 0
        ) {
          this.successMsg('Brak zmian do zapisania.');
          return;
        }

        try {
          const response = await axios.post(route('orderListsItems.saveChanges'), payload);

          this.successMsg(response.data.message || 'Poprawnie zapisano zmiany.');

        } catch (error) {
          console.error(error);
          const errors = error.response?.data;
          if (Array.isArray(errors)) {
            errors.forEach(err => {
              this.errorMsg(err)
            });
          } else {
            this.errorMsg('Wystąpił błąd zapisu:' + errors)
          }
        } finally {
          // Odśwież dane w gridzie
          this.$emit('refresh', true);
          this.getItems(this.orderListId);
        }
      }

      /**
       * Akcja przy kliknięciu resetowania filtrów
       */
      if (args.item.id === 'reset_filters') {
        this.$refs.orderListItemsGrid.clearFiltering();
      }
if (args.item.id === 'save') {
    const grid = this.$refs.orderListItemsGrid?.ej2Instances;

    if (!grid) {
        console.warn('Grid nie został znaleziony');
        this.errorMsg("Konfiguracja tabeli nie została zapisana!");
        return;
    }

    const tableId = 'orderListItemsGrid';

    const settings = grid.columns.map((column, index) => ({
        field: column.field || null,
        index: index,
        width: column.width,
        visible: column.visible !== false
    }));

    try {
        await axios.post('/table-settings', {
            tableId: tableId,
            columns: JSON.stringify(settings)
        });

        this.hasTableSettingsSel = true;

        grid.toolbar = this.getToolbar();
        this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");

    } catch (error) {
        console.error('Błąd zapisu:', error.response?.data || error);

        this.errorMsg("Konfiguracja tabeli nie została zapisana!");
    }
}

if (args.item.id === 'delete-set') {
    const tableId = 'orderListItemsGrid';

    try {
        await axios.delete('/table-settings-delete', {
            data: {
                tableId: tableId
            }
        });

        this.hasTableSettingsSel = false;

        const grid = this.$refs.orderListItemsGrid?.ej2Instances;

        if (grid) {
            grid.toolbar = this.getToolbar();
        }

        this.successMsg("Konfiguracja tabeli została pomyślnie usunięta!");

    } catch (error) {
        console.error('Błąd usuwania:', error.response?.data || error);

        this.errorMsg("Konfiguracja tabeli nie została usunięta!");
    }
}

      if (args.item.id === 'restore') {
        let grid = this.$refs.orderListItemsGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
		this.applyTableSettings();
        location.reload();
      }

if (args.item.id === 'excelexport') {

    const grid = this.$refs.orderListItemsGrid;

    const hiddenColumns = [
        'was_edited_later',
    ];

    hiddenColumns.forEach(field => {
        const col = grid.getColumnByField(field);
        if (col) {
            col.visible = false;
        }
    });

    grid.refreshColumns();

    grid.excelExport({
        fileName: 'Zamówienia.xlsx',
        includeAggregate: false
    }).then(() => {

        hiddenColumns.forEach(field => {
            const col = grid.getColumnByField(field);
            if (col) {
                col.visible = true;
            }
        });

        grid.refreshColumns();
    });
}
	  
	  
	  
    },

    rowSelecting(args) {
      if (this.preventRightClickSelection) {
        args.cancel = true;
        this.preventRightClickSelection = false;
        return;
      }

      if (args.data.deleted_at) {
        args.cancel = true; // blokuj zaznaczenie
        Toast.fire({
          icon: 'info',
          title: 'Nie można zaznaczyć usuniętego rekordu.'
        });
      }
    },

    getContextMenu() {
      const contextMenu = [];

      if (hasPermission('canEditOrders')) {
        contextMenu.push(
            {text: 'Duplikuj pozycje', target: '.e-content', id: 'duplicate_order_item'},
       )
      }

      if (hasPermission('canChangeStatusApprovalOrders')) {
        contextMenu.push(
            {text: 'Zmień status', target: '.e-content', id: 'change_status'},
        );
      }

      if (hasPermission('canWarehouseDispositions')) {
        contextMenu.push(
            {separator: true},
            {text: 'Dyspozycja magazynowa', target: '.e-content', id: 'warehouse_disposition', enabled: false},
        )
      }

      return contextMenu;
    },


    onContextMenuOpen(args) {
      const grid = this.$refs.orderListItemsGrid;
      const selected = grid.getSelectedRecords();

      // brak zaznaczenia → NIE MA MENU
      if (!selected.length) {
        args.cancel = true;
        return;
      }

      const menu = args.element.ej2_instances[0];

      // ---- BLOKADY / ENABLE ----

      // Dyspozycja magazynowa – tylko gdy wszystkie rekordy OK
      const hasDeleted = selected.some(r => r.deleted_at);
      menu.enableItems(['Dyspozycja magazynowa'], !hasDeleted);

      // Zmień status – zawsze przy zaznaczeniu
      menu.enableItems(['Zmień status'], true);

      // Duplikuj – tylko przy >=1
      menu.enableItems(['Duplikuj pozycje'], selected.length >= 1);
    },

    clickContextMenuHandler(args) {
      // zmiana statusu
      if (args.item.id === 'change_status') {
        this.selectedRecordsStat = this.$refs.orderListItemsGrid.getSelectedRecords();
        this.$nextTick(() => {
          this.$refs.changeStatusModalRef.show();
        })
      }

      // dyzpozycja magazynowa
      if (args.item.id === 'warehouse_disposition') {
        this.selectedRecordsToMove = this.$refs.orderListItemsGrid.getSelectedRecords();
        this.$refs.moveItemToWarehouseModal.show();
      }

      // Duplikuj pozycję
      if (args.item.id === 'duplicate_order_item') {
        Toast.fire({
          toast: false,
          position: 'center',
          icon: 'question',
          title: 'Klonowanie wierszy',
          html: 'Czy na pewno chcesz zduplikować wybrane wiersze?',
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: false,
          showConfirmButton: true,
          confirmButtonText: 'Tak',
          confirmButtonColor: 'success',
          showCancelButton: true,
          cancelButtonText: 'Nie',
        }).then((result) => {
          if (result.isConfirmed) {

            let rowsToDuplicate = this.$refs.orderListItemsGrid.getSelectedRecords();
            this.$nextTick(() => {
axios.post(route('orderLists.item.duplicate'), {
    orderListsItems: rowsToDuplicate
}
              ).then(response => {
                if (response.status === 200) {
                  this.successMsg('Wiersze skopiowane');
                  this.$emit('refresh', true);
                  this.$nextTick(() => {
                    this.refreshItemGrid();
                  })

                } else {
                  this.errorMsg('Coś poszło nie tak: ', response.data.message);
                }
              }).catch(error => {
                console.log(error);
              });
            })
          }
        })
      }
    },

    cellEdit(args) {
      if (!hasPermission('canEditOrders') && hasPermission('canChangeStatusApprovalOrders')) {
        if (args.columnName !== 'status.id') {
          args.cancel = true;
        }
      }
    },

    findStatusByName(name) {
      return this.order_list_statuses?.find(s => s.name === name) || null;
    },

    getRowIndexById(id) {
      const ej = this.$refs.orderListItemsGrid?.ej2Instances;
      if (!ej) return -1;
      // preferowana metoda (jeśli dostępna)
      if (typeof ej.getRowIndexByPrimaryKey === 'function') {
        return ej.getRowIndexByPrimaryKey(id);
      }
      // fallback na currentViewData
      const view = ej.getCurrentViewRecords?.() || ej.currentViewData || [];
      return view.findIndex(r => r.id === id);
    },

    onCellSave(args) {

      //
      // ZMIANA STATUSU PRZY WPROWADZANIU ILOŚCI DOSTARCZONEJ
      //
      if (args.columnName !== 'delivered_quantity') return;

      const ej = this.$refs.orderListItemsGrid?.ej2Instances;
      if (!ej) return;

      const rowData = args.rowData || {};
      const delivered = Number(args.value ?? 0);
      const required = Number(rowData.quantity_required ?? 0);

      const S_REAL = this.findStatusByName('Zrealizowane');
      const S_PART = this.findStatusByName('Częściowo zrealizowane');
      const S_PROGRESS = this.findStatusByName('W trakcie realizacji');

      // walidacja minimalna
      if (!isFinite(delivered) || !isFinite(required)) return;

      // === REGUŁY DECYZYJNE ===
      let target = null;

      if (delivered === required && S_REAL) {
        target = S_REAL;
      } else if (delivered > required && S_PART) {
        target = S_PART;               // nad-dostawa -> "Częściowo zrealizowane"
      } else if (delivered > 0 && delivered < required && S_PART) {
        target = S_PART;               // częściowa dostawa
      } else if (delivered === 0 && S_PROGRESS) {
        target = S_PROGRESS;           // nic nie dostarczono
      }

      // brak decyzji albo bez zmiany – wychodzimy
      const currentId = rowData.status?.id ?? null;
      if (!target || currentId === target.id) return;

      // aktualizacja lokalnego obiektu (żeby template koloru/nazwy "od razu" się odświeżył)
      rowData.status = {id: target.id, name: target.name};

      // oznaczenie zmiany w batchu (to jest kluczowe – NIE używamy setRowData / refreshRow)
      const rowIndex = this.getRowIndexById(rowData.id);
      if (rowIndex > -1 && ej.editModule?.updateCell) {
        try {
          ej.editModule.updateCell(rowIndex, 'status.id', target.id);
        } catch (e) {
          // awaryjnie – jeśli z jakiegoś powodu updateCell nie chwyci, dopiszemy ręcznie do changedRecords:
          try {
            const bc = ej.getBatchChanges?.();
            if (bc && Array.isArray(bc.changedRecords)) {
              const i = bc.changedRecords.findIndex(r => r.id === rowData.id);
              if (i > -1) {
                bc.changedRecords[i].status = {id: target.id, name: target.name};
              } else {
                bc.changedRecords.push({...rowData, status: {id: target.id, name: target.name}});
              }
            }
          } catch {
          }
        }
      }

      try {
        const tr = ej.getRowByIndex?.(rowIndex);
        if (tr) {
          tr.style.transition = 'background-color .35s';
          tr.style.backgroundColor = '#c3f3c3';
          setTimeout(() => (tr.style.backgroundColor = ''), 600);
        }
      } catch {
      }

    },

    actionBeginHandler(args) {
      if (args.requestType === 'searching') {
        const keys = args.searchString.split(';');
        let flag = true;
        let predicate;

        if (this.$refs.orderListItemsGrid.ej2Instances.searchSettings.key !== '') {
          this.values = args.searchString;
          keys.forEach((key) => {
            this.$refs.orderListItemsGrid.ej2Instances.getColumns().forEach((col) => {
              if (flag) {
                predicate = new Predicate(col.field, 'contains', key, true);
                flag = false;
              } else {
                let predic = new Predicate(col.field, 'contains', key, true);
                predicate = predicate.or(predic);
              }
            });
          });

          this.$refs.orderListItemsGrid.ej2Instances.query = new Query().where(predicate);
          this.$refs.orderListItemsGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.orderListItemsGrid.ej2Instances.refresh();
        } else {
          this.$refs.orderListItemsGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.orderListItemsGrid.ej2Instances.refresh();
        }
      }
    },

    actionCompleteHandler(args) {
      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh" && this.valueAssign) {
        document.getElementById(
            this.$refs.orderListItemsGrid.ej2Instances.element.id + "_searchbar"
        ).value = this.values;
        this.valueAssign = false;
      } else if (
          document.getElementById(
              this.$refs.orderListItemsGrid.ej2Instances.element.id + "_searchbar"
          ).value === "" &&
          args.requestType === "refresh" &&
          this.removeQuery
      ) {
        this.$refs.orderListItemsGrid.ej2Instances.query = new Query();
        this.removeQuery = false;
        this.$refs.orderListItemsGrid.ej2Instances.refresh();
      }

      if (args.requestType === "batchsave") {  // Tylko dla operacji batchSave (zapis)
        if (args.changes && args.changes.changedRecords) {
          // Sprawdzamy, czy `args.batchChanges` istnieje i czy są zmienione rekordy
          this.successMsg("Dane zostały pomyślnie zapisane!");

        } else if (args.error) {
          // Jeśli wystąpił błąd, wywołaj `errorMsg` z wiadomością błędu
          this.errorMsg("Wystąpił błąd podczas zapisu danych: " + args.error);
        }
      }
    },

    async onChangeStatus(event, rowData) {
      // Jeżeli user zmienił status na Zrealizowane
      if (!event.itemData || event.itemData?.name !== 'Zrealizowane') {
        return;
      }

      // Sprawdź, czy dostarczona ilość === wydanej ilości. Jeśli NIE:
      if (parseFloat(rowData.delivered_quantity) !== parseFloat(rowData.dispatched_quantity)) {
        Toast.fire({
          toast: false,
          position: 'center',
          icon: 'warning',
          title: 'Zakończenie zamówienia',
          html: 'Aby dokończyć realizacje zamówienia, dostarczona ilość oraz wydana ilość musi być taka sama.',
          showClass: {popup: 'animate__animated animate__fadeInDown'},
          hideClass: {popup: 'animate__animated animate__fadeOutUp'},
          timer: false,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Ok, rozumiem',
        });

        // cofnij do poprzedniego statusu
        return event.previousItemData?.id;
      }

      const result = await Toast.fire({
        toast: false,
        position: 'center',
        icon: 'question',
        title: 'Zakończenie zamówienia',
        html: 'Czy na pewno chcesz zmienić status na zrealizowany? To zamówienie będzie zakończone.',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        confirmButtonColor: 'success',
        showCancelButton: true,
        cancelButtonText: 'Nie',
      });

      if (result.isConfirmed) {
        let response = await axios.post(route('orderLists.order-completed', {orderListItem: rowData.id}))
        if (response.status === 200) {
          this.successMsg(response);
        }
        this.$refs.orderListGrid.refresh();
      } else {
        // cofnij do poprzedniego statusu
        return event.previousItemData?.id;
      }
    },

    onKeyDown: function (args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

      // code 83 to 'S'
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();

        this.updateGrid();
      }
    },

    updateGrid() {
      // aktualizuj
      let toolbar = document.getElementsByClassName('e-toolbar-left')[1];
      let buttons = toolbar.querySelectorAll('.e-toolbar-item');
      let updateButton = buttons[1].querySelector('button');


      if (updateButton) {
        updateButton.click();
      }
    },

    refreshItemGrid() {
      this.getItems(this.orderListId);
    },

    getStatusColor(status) {
      if (!status?.id) return '#ccc';
      const color = this.order_list_statuses.find(s => s.id === status.id) ?? '#ccc';
      return color.bg_color ?? '#ccc';
    },

    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },
  }
}
</script>


<style>
#orderListItemsGridId .e-headercell, #orderListItemsGridId .e-rowcell {
  font-size: 12px;
}

.fullscreen-wrapper {
  position: relative;
  transition: all .3s ease-in-out;
}

.fullscreen-wrapper.fullscreen {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  margin-top: 55px;
  background: #fff;
  overflow: auto;
  transform: scale(1);
  opacity: 1;
}

.fullscreen-wrapper {
  transform: scale(0.98);
  opacity: .95;
}

.fullscreen-wrapper .e-grid .e-toolbar {
  top: 20px !important;
}

.fullscreen-wrapper .e-grid .e-gridheader {
  top: 55px !important;
}

.e-grid .e-checkwrap .e-frame.e-check {
    background: #ca6e1b !important;
    border-color: #ca6e1b !important;
}

.e-grid .e-checkwrap .e-frame.e-check::before {
    color: #fff !important;
}
.e-grid .e-headercell {
    padding-left: 0 !important;
}

.e-grid .e-headercell .e-headercelldiv {
    padding-left: 0 !important;
    margin-left: 0 !important;
}
</style>